import { DomainError } from '@/errors';

export class AuthDomainError extends DomainError {
  get isUnauthorized() {
    return this.code === 'LOCAL_UNAUTHORIZED';
  }
}
